const dispatchBoardConstants = {
  LIMIT_SEARCH_DAYS: 32,
  LIMIT_DOWNLOAD_DAYS: 93,
  LIMIT: 50,
  PAGE_SIZE: 50,
};

export default dispatchBoardConstants;
